function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "kladka1");

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "kladka1"
}, React.createElement("path", {
  d: "M28.5,32.583 C28.5,32.4314137 28.5635439,32.3095009 28.627167,32.253646 C28.6101746,32.2685637 28.5400134,32.3054325 28.4288096,32.3436405 C28.1455878,32.4409513 27.7319514,32.5 27.364,32.5 L2.807,32.5 C2.54595849,32.5 2.40620961,32.4705234 2.38721491,32.457835 C2.4591263,32.5058715 2.5,32.5920032 2.5,32.583 L2.5,14.226 C2.5,13.8726954 2.73418563,13.5 2.807,13.5 L27.364,13.5 C27.5016712,13.5 27.8262658,13.64882 28.1206851,13.8895987 C28.3617342,14.0867309 28.5,14.2867833 28.5,14.226 L28.5,32.583 L28.5,32.583 Z M30.5,32.583 L30.5,14.226 C30.5,12.9539239 28.7221718,11.5 27.364,11.5 L2.807,11.5 C1.38427086,11.5 0.5,12.9072755 0.5,14.226 L0.5,32.583 C0.5,33.879491 1.428912,34.5 2.807,34.5 L27.364,34.5 C29.0295407,34.5 30.5,33.9947719 30.5,32.583 L30.5,32.583 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M6.417,12.15999 C6.417,7.03277475 10.5737847,2.87599 15.702,2.87599 C20.8302153,2.87599 24.987,7.03277475 24.987,12.15999 L26.987,12.15999 C26.987,5.92820525 21.9347847,0.87599 15.702,0.87599 C9.46921525,0.87599 4.417,5.92820525 4.417,12.15999 L6.417,12.15999 L6.417,12.15999 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M19.807,21.27101 C19.807,18.9010236 17.8835831,16.97801 15.514,16.97801 C13.1431103,16.97801 11.222,18.9003298 11.222,21.27101 C11.222,22.668137 11.8940323,23.9526456 13.0049739,24.7540245 L12.59,23.94301 L12.59,25.14501 C12.594573,26.7545985 13.8983955,28.05701 15.506,28.05701 C17.1136847,28.05701 18.4194762,26.7531021 18.4209996,25.1459579 L18.421,23.95501 L18.0014116,24.7693333 C19.125402,23.9682054 19.807,22.6769421 19.807,21.27101 L19.807,21.27101 Z M17.807,21.27101 C17.807,22.0228057 17.4439097,22.7106675 16.8405884,23.1406867 L16.421,23.4397497 L16.421,23.95501 L16.421,25.14501 C16.4205236,25.6471557 16.0100773,26.05701 15.506,26.05701 C15.001533,26.05701 14.5914325,25.6473534 14.589996,25.1421664 L14.59,23.94301 L14.59,23.4313374 L14.1750261,23.1319955 C13.5798735,22.7026816 13.222,22.0186496 13.222,21.27101 C13.222,20.0046176 14.2479617,18.97801 15.514,18.97801 C16.7791075,18.97801 17.807,20.005687 17.807,21.27101 L17.807,21.27101 Z",
  id: "Shape"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "31px",
    height: "35px",
    viewBox: "0 0 31 35",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/custom-kladka.0c3bb1b4.svg";
export { SvgComponent as ReactComponent };